
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestcardprocessingrates/contact-us",
      function () {
        return require("private-next-pages/bestcardprocessingrates/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestcardprocessingrates/contact-us"])
      });
    }
  